export const tableColSetup = ({fontSize, fontWeight, paddingVert, paddingHorz}) => `
    font-size: ${fontSize || 'var(--table-column-body-text-size)'};
    line-height: ${fontSize || 'var(--table-column-body-text-size)'};
    font-weight: ${fontWeight || '400'};
    padding: ${paddingVert || '7px'} ${paddingHorz || '12px'} ${paddingVert || '9px'};
    vertical-align: middle;
    position: relative;
    border: none;
    &:last-of-type {
        border-radius: 0 var(--table-border-radius) var(--table-border-radius) 0;
    }
    &:first-of-type {
        border-radius: var(--table-border-radius) 0 0 var(--table-border-radius);
    }
`;

export const columnAlignment = (textAlign) => {
    if (textAlign === 'center')
        return `
                text-align: center;
            `;
    else if (textAlign === 'right')
        return `
            text-align: right;
        `;
    else return '';
};

const tableHoverSetup = (hover) => {
    if (hover)
        return `
        tbody tr{
            cursor: pointer;
            td {
                transition: 0.2s;
            }
            &:hover {
                transition: 0.6s;
                td {
                    transition: 0.6s;
                    background: var(--table-data-row-background-hover);
                    @-moz-document url-prefix() {
                        background: var(--table-data-row-background-hover)!important;
                    }
                }
            }
        }
    `;
    else return ``;
};

export {tableHoverSetup};
